import { FeatureAnnouncement } from 'src/constants/featureAnnouncements';

export function getFeatureAnnouncementLocalStorageKey(
	announcement: FeatureAnnouncement
) {
	return `announcement_${announcement.name}_${announcement.addedDateTsMillis}_seen`;
}
